import { Link } from "gatsby"
import styled from "styled-components"

import media from "../../../styles/media"

export const NavLink = styled(Link)`
  color: ${props => (props.dark ? props.theme.black : props.theme.white)};
  display: flex;
  text-decoration: none;

  :hover {
    color: ${props => props.theme.red};
  }

  ${media.tablet`
    margin: 0 1em 0 0;
    padding: 0;
  `}
`
